import { render, staticRenderFns } from "./LoginСlient.vue?vue&type=template&id=6b371cb4&scoped=true&"
import script from "./LoginСlient.vue?vue&type=script&lang=js&"
export * from "./LoginСlient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b371cb4",
  null
  
)

export default component.exports